module.exports = __webpack_public_path__ + "static/img/site-1.40f29e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-1.png
// module id = OnvG
// module chunks = 0